import { brandSchema, brandsSchema } from "./schema";
import { getEntity, getEntityIds, getEntities } from "./base";
import { PRODUCT_TYPES } from "../constants/productTypes";

const path = "/portal/api/brands";

const getBrand = (clientConfig, entityId) => {
  return getEntity(clientConfig, entityId, path, brandSchema);
};

const getBrandIds = (clientConfig, offerType, dataStatus) => {
  return getEntityIds(
    clientConfig,
    dataStatus,
    path,
    offerType,
    clientConfig.limits
  );
};

const getBrands = (clientConfig, dataStatus) => {
  let limits = { ...clientConfig.limits };
  limits.dataSpeedGen = [];
  limits.providerId = [];

  return getEntities(
    clientConfig,
    dataStatus,
    path,
    brandsSchema,
    { productType: PRODUCT_TYPES.phone },
    limits
  );
};

export { getBrand, getBrandIds, getBrands };
